import { Navigate, createBrowserRouter } from "react-router-dom";

import { GuestRoute } from "@/auth/GuestRoute";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { AccountPage } from "@/pages/AccountPage";
import { ApplicationDetailPage } from "@/pages/ApplicationDetailPage";
import { ApplicationsPage } from "@/pages/ApplicationsPage";
import { CreateApplicationPage } from "@/pages/CreateApplicationPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { LoginPage } from "@/pages/LoginPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";

export const router = createBrowserRouter([
  {
    element: <GuestRoute />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/forgot-password", element: <ForgotPasswordPage /> },
      { path: "/reset-password", element: <ResetPasswordPage /> },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      { path: "/", element: <Navigate to="/applications" replace /> },
      { path: "/applications", element: <ApplicationsPage /> },
      { path: "/applications/new", element: <CreateApplicationPage /> },
      { path: "/applications/:uuid", element: <ApplicationDetailPage /> },
      { path: "/account", element: <AccountPage /> },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
